import Axios from 'axios';

export default {
  getInputBills(billingId) {
    return Axios.get('/admin/debt-agreements/input-bills', {
      params: {
        billing_id: billingId,
      },
    });
  },

  create(inputBills, options) {
    return Axios.post('/admin/debt-agreements', {
      input_bills: inputBills,
      debt_agreement_options: options,
    });
  },
};
